import { useEffect } from 'react'
import { track } from './analytics'

const DEPTHS = [25, 50, 75, 100] as const

/** scroll_depth at 25/50/75/100 %, each once per mount (page view). */
export function useScrollDepth(): void {
  useEffect(() => {
    const fired = new Set<number>()
    const onScroll = () => {
      const doc = document.documentElement
      const total = doc.scrollHeight
      if (total <= 0) return
      const pct = ((window.scrollY + window.innerHeight) / total) * 100
      for (const d of DEPTHS) {
        if (!fired.has(d) && pct >= (d === 100 ? 98 : d)) {
          fired.add(d)
          track('scroll_depth', { depth: d })
        }
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])
}
